import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragDropContainer } from "react-drag-drop-container";
import "../style.css";
import numeral from "numeral";
import moment from "moment";
import RegimeFields from "./regimes";
import DestinationFields from "./destination";
import AmountsFields from "./amounts";
import { VaporRangeDatePicker } from "../../../../vapor";
import AliquoteFields from "./aliquote";
import { useDispatch, useSelector } from "react-redux";
import { deleteSingleAccountingLine } from "../../../../../store/actions/precog/accountingLines";
import { getInvoiceDetail } from "../../../../../store/actions/precog";
import { Input } from "antd";

const ArticleRowNew = ({
  article,
  articleId,
  contoId,
  droppingOn,
  onArticleDrag,  
  setCurrentItem,
  allowDrag,
  setAllowDrag,
  lockDrag,
  setLockDrag,
  setDraggingFrom,
  draggingFrom,
  index,
  changeArticle,
  isMonoRegime,
  isDocument,
  jsonCurrency,
  refCurrency,
  reasonId,
  setOpenSplitModal,
  isIncomeStatement,
  setExpandedRow,
  natureVal,
  setNatureVal,
  setDrawerNature,
  setCurrentArticles,
  currentArticles,
  draftId
}) => {

  const dispatch = useDispatch();
  const [dropData, setDropData] = useState({});
  const [dates, setDates] = useState([]);
  const [articleDescription, setArticleDescription] = useState(null);
  const [uuidToDelete, setUuidToDelete] = useState(null);

  const isDeletingLine = useSelector(state => state.precog.deleteAccountingGroupLine?.isLoading);

  useEffect(() => {
    if (!article?.startPeriodDate && !article?.endPeriodDate || !isIncomeStatement) return;
    setDates([article?.startPeriodDate ? moment.unix(article.startPeriodDate) : undefined, article?.endPeriodDate ? moment.unix(article.endPeriodDate) : undefined]);
  }, [article?.startPeriodDate, article?.endPeriodDate]);

  useEffect(() => {
    if (!lockDrag) {
      setAllowDrag(false);
    }
  }, [lockDrag]);

  useEffect(() => {
    if (draggingFrom) {
      setDropData({ ...dropData, from: draggingFrom });
    }
  }, [draggingFrom]);

  useEffect(() => {
    setArticleDescription(article?.articleDesc);
  }, [article.articleDesc]);
  
  const onArticleChange = (kind, value) => {
    const clonedArticles = [...currentArticles];
    let articleToModify = clonedArticles.find(el => el.uuid === article.uuid);
    articleToModify[kind] = value;
    setCurrentArticles(clonedArticles);
    changeArticle({ uuid: article.uuid, type: kind, value: value }, index);
  };

  const onArticleDelete = () => {
    dispatch(deleteSingleAccountingLine(draftId, article.uuid)).then(() => {
      const clonedArticles = [...currentArticles];
      let articleToSave = clonedArticles.filter(el => el.uuid !== article.uuid);
      setCurrentArticles(articleToSave);
      setUuidToDelete(null);      
      // refresh all detail because can change "imponibile"
      dispatch(getInvoiceDetail(draftId));
    }).catch(() => setUuidToDelete(null));
  };

  return (
    <div data-testid="ArticleRowNew" id={"articles_ddcontainer" + contoId}>
      <DragDropContainer
        key={"ddcontainer_" + contoId}
        noDragging={!lockDrag && !allowDrag}
        onDragStart={() => {
          setLockDrag(true);
          setDraggingFrom(contoId);
        }}
        onDragEnd={() => {
          setLockDrag(false);
          // onResizeWidthChange();
          setDraggingFrom(null);
          onArticleDrag({ ...dropData, to: droppingOn, article: article });
        }}
        targetKey="precog-articles-drag"
        dragData={{ rowId: contoId }}
      >
        <>
          <div
            id={"articles-accordion_" + contoId}
            key={"articles-accordion_" + contoId}
            className={"articles-accordion" + (!allowDrag ? " noDragging" : "")}
          >
            <div
              className="articles-accordion-col col-1 articles-accordion-actions"
              key={"articles-accordion_col1_" + contoId}
              style={{
                width: "32px",
                display: "flex",
                justifyContent: "center"
              }}
              onMouseEnter={() => setAllowDrag(true)}
              onMouseLeave={() => {
                if (!lockDrag) {
                  setAllowDrag(false);
                }
              }}             
            >
              <FontAwesomeIcon icon={["far", "grip-lines"]} />
            </div>          

            <div
              key={"articles-accordion_col1_" + contoId + article.articleDesc}
              className="articles-accordion-col col-2"
              style={{ width: "22.5%" }}
            >
              <div style={{ paddingLeft: 14 }}>
                {
                  !isDocument ? 
                    article.articleDesc : 
                    <div>
                      <Input
                        style={{background: "#def0f7", margin: "-10px -8px", border: 0}}
                        className="inputCustom "                        
                        value={articleDescription}
                        placeholder="Nome articolo"
                        onChange={e => {
                          setArticleDescription(e.target.value);
                        }}
                        onBlur={() => {
                          if (!articleDescription) {                            
                            onArticleChange("fieldsToDelete", "articleDesc");
                          } else {                            
                            onArticleChange("articleDesc", articleDescription);
                          }
                        }}
                      />
                    </div>
                }
              </div>
            </div>
            
            <div
              onMouseEnter={() => setAllowDrag(false)}
              onMouseLeave={() => setAllowDrag(true)}
              key={"articles-accordion_col2_" + contoId}
              className="articles-accordion-col col-3"
              style={{ width: "20%", display: "flex" }}
            >
              <RegimeFields
                isMonoRegime={isMonoRegime}
                article={article}
                onArticleChange={onArticleChange}
                isAccountRow={true}
              />
            </div>
            {
              reasonId === "CO1" &&
                <div
                  className="articles-accordion-col col-4"
                  key={"articles-accordion_col5_" + contoId}
                  style={{ width: "6.5%" }}
                >
                  <AmountsFields article={article} type="credit" jsonCurrency={jsonCurrency} refCurrency={refCurrency} onArticleChange={onArticleChange} />
                </div>
            }
            <div
              onMouseEnter={() => setAllowDrag(false)}
              onMouseLeave={() => setAllowDrag(true)}
              className={`articles-accordion-col ${reasonId === "CO1" ? "col-5" : "col-4"}`}
              key={"articles-accordion_col3_" + contoId}
              style={{ width: "8%", display: "flex" }}
            >
              {isDocument || article.vatRate === "0.0" ? <AliquoteFields
                article={article}
                articleId={articleId}
                contoId={contoId}
                setCurrentItem={setCurrentItem}
                index={index}
                changeArticle={changeArticle}
                setDrawerNature={setDrawerNature}
                natureVal={natureVal}
                setNatureVal={setNatureVal}
                isDocument={isDocument}
                onArticleChange={onArticleChange}
                isAccountRow={true}
              /> :
                article.vatRate !== "0.0" ?
                  <div>{article.vatRate}%</div> :
                  <div>{article?.exemptionNature ? `0% - ${article?.exemptionNature}` : "0%"}</div>}
            </div>
            {
              reasonId === "CO1" &&
                <div
                  className="articles-accordion-col col-6"
                  key={"articles-accordion_col6_" + contoId}
                  style={{ width: "6.5%" }}
                >
                  {article.credit !== 0
                    ? `${numeral((article.credit * article.vatRate)/100).format("0,0.00")} €`
                    : <>-</>
                  }
                </div>
            }
            <div
              onMouseEnter={() => setAllowDrag(false)}
              onMouseLeave={() => setAllowDrag(true)}
              className={`articles-accordion-col ${reasonId === "CO1" ? "col-7" : "col-5"}`}
              key={"articles-accordion_col4_" + contoId}
              style={{ width:  reasonId === "CO1" ? "15%" : "10%", display: "flex" }}
            >
              <DestinationFields article={article} onArticleChange={onArticleChange} isAccountRow={true}/>
            </div>
            {
              reasonId !== "CO1" &&              
                <div
                  className="articles-accordion-col col-6"
                  key={"articles-accordion_col5_" + contoId}
                  style={{ width: "6.5%" }}
                >
                  {isDocument ? 
                    <AmountsFields  article={article} type="debit" jsonCurrency={jsonCurrency} refCurrency={refCurrency} onArticleChange={onArticleChange} />
                    : article.debit !== 0
                      ? `${numeral(Math.abs(article.debit)).format("0,0.00")} €`
                      : <>&nbsp;</>}
                </div>
            }
            {
              reasonId !== "CO1" &&
                <div
                  className="articles-accordion-col col-7"
                  key={"articles-accordion_col6_" + contoId}
                  style={{ width: "6.5%" }}
                >
                  {isDocument ? 
                    <AmountsFields  article={article} type="credit" jsonCurrency={jsonCurrency} refCurrency={refCurrency} onArticleChange={onArticleChange} />
                    : article.credit !== 0
                      ? `${numeral(Math.abs(article.credit)).format("0,0.00")} €`
                      : <>&nbsp;</>}
                </div>
            }
            {
              reasonId !== "CO1" ?
                <div
                  className="articles-accordion-col col-8"
                  key={"articles-accordion_col7_" + contoId}
                  style={{ width: "10%" }}
                  onMouseEnter={() => setAllowDrag(false)}
                >
                  {isIncomeStatement ? <VaporRangeDatePicker
                    value={dates}
                    className="conti-contabili-date"
                    allowEmpty={[true, true]}
                    customTrigger={true}
                    onChange={value => {
                      if (!value) {
                        setDates([null, null]);
                        onArticleChange("fieldsToDelete", ["startPeriodDate", "endPeriodDate"]);
                      } else {
                        setDates([value[0], value.length > 1 ? value[1] : null]);
                        onArticleChange(["startPeriodDate", "endPeriodDate"], [value[0], value.length > 1 ? value[1] : null]);
                      }
                    }}
                  /> : <div>&nbsp;</div>}
                </div>
                :
                <div
                  className="articles-accordion-col col-8"
                  key={"articles-accordion_col7_" + contoId}
                  style={{ width: 150 }}
                  onMouseEnter={() => setAllowDrag(false)}
                >              
                  {article.credit !== 0
                    ? `${numeral(article.credit + (article.credit * article.vatRate)/100).format("0,0.00")} €`
                    : <>-</>
                  }
                </div>
            }
            <div
              className="articles-accordion-col col-9"
              key={"articles-accordion_col8_" + contoId}
              style={{ width: "4%" }}
            >
              &nbsp;
            </div>
            {!isDocument ? <div
              className="articles-accordion-col col-10"
              key={"articles-accordion_col9_" + contoId}
              style={{ width: "20px", cursor: "pointer", textAlign: "center" }}
              onMouseEnter={() => setAllowDrag(false)}
              onClick={() => {
                setExpandedRow([]);
                setOpenSplitModal(true);
                setCurrentItem({
                  currentLine: contoId,
                  currentArticle: article
                });
              }}
            >
              {draggingFrom ? <div> &nbsp;</div> : <FontAwesomeIcon icon={["far", "edit"]} />}
            </div> : <div
              className="articles-accordion-col col-10"
              key={"articles-accordion_col9_" + contoId}
              style={{ width: "20px", cursor: "pointer", textAlign: "center" }}
              onMouseEnter={() => setAllowDrag(false)}
              onClick={() => {                                
                setUuidToDelete(article.uuid);
                onArticleDelete();
              }}
            >
              {draggingFrom ? <div> &nbsp;</div> :
                isDeletingLine && uuidToDelete === article?.uuid ?
                  <FontAwesomeIcon icon={["far", "circle-notch"]} style={{fontSize: "14px"}} spin /> :
                  <FontAwesomeIcon icon={["far", "trash-alt"]} />}
            </div>}
          </div>
        </>
      </DragDropContainer>
    </div>
  );
};

export default ArticleRowNew;
